import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, call } from '../client';
import { queryKeys } from './keys';

export const fetchWorkspaces = () => call(api.GET('/v1/workspaces'));
export type Workspace = Awaited<ReturnType<typeof fetchWorkspaces>>['workspaces'][number];

export function useWorkspaces() {
  return useQuery({ queryKey: queryKeys.workspaces, queryFn: fetchWorkspaces });
}

export function useRenameWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      workspaceId,
      ...body
    }: {
      workspaceId: string;
      name?: string;
      timezone?: string;
    }) =>
      call(
        api.PATCH('/v1/workspaces/{workspaceId}', {
          params: { path: { workspaceId } },
          body,
        }),
      ),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: queryKeys.workspaces });
      await qc.invalidateQueries({ queryKey: queryKeys.me });
    },
  });
}

/** Remembers the active workspace (per person) and refreshes everything shown. */
export function useActivateWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (workspaceId: string) =>
      call(
        api.POST('/v1/workspaces/{workspaceId}/activate', { params: { path: { workspaceId } } }),
      ),
    onSuccess: () => qc.invalidateQueries(),
  });
}
